import { Component, OnInit } from '@angular/core';
import { Menu, MenuLink } from '../../shared/legal-system.model';

import { LegalSystemsService } from '../../services/legal-systems.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.css'
})
export class MenuComponent  implements OnInit {
  isMenuOpen = false
  menu:MenuLink[] = [];

  constructor (private readonly legal: LegalSystemsService) {}

  ngOnInit (): void {
      this.legal.getSharedMenu('menu').subscribe((menuItems: Menu)=>{
      this.menu = menuItems.links;
    });
  }

   trackById (index: number, item: { id: number }): number {
    return item.id
  }
}
